import definuj_front from "../assets/karty/Definuj.svg"
import definuj_back from "../assets/karty/Definuj-linka-vlastnosti.svg"

import rozhoduj_front from "../assets/karty/Rozhoduj.svg"
import rozhoduj_back from "../assets/karty/Rozhoduj-UIP-test.svg"

import vymyslej_front from "../assets/karty/Vymyslej.svg"
import vymyslej_back from "../assets/karty/Vymyslej-inverze.svg"

import { useState } from "react"

const Karticka = ({type, className='', ...rest}) => {
    const [flipped, setFlipped] = useState(false);
    const width = Math.min(window.innerWidth,1200)/4;
    return (
        <div className={(flipped?'flipped':'')+" card w-full rounded-xl aspect-[2/3] flex justify-center items-center bg-white "+className} 
        // style={{width:width+'px'}}
         onClick={()=>{setFlipped(!flipped)}} {...rest}>
            <div className="card__face front">
                <img src={type==='definuj'?definuj_front:type==='rozhoduj'?rozhoduj_front:vymyslej_front} />
            </div>
            <div className="card__face back">
                <img src={type==='definuj'?definuj_back:type==='rozhoduj'?rozhoduj_back:vymyslej_back} />
            </div>
        </div>
    )
}

export default Karticka;